import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import { set, cloneDeep, get, sum } from 'lodash';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { customStyles, roundingOff, allowOnlyNumber, currency_symbols } from '../../../../../Components/helper';
import { colourPath } from '../../fieldPath';
import { usePurchaseOrderState } from '../../PurchaseOrderContext/index';
import useDestinationPackedUnits from '../../Hooks/useDestinationPackedUnits';
import useGrandTotal from '../../Hooks/useGrandTotal';
import CustomDatePicker from '../../../../../Components/Utility/DatePicker/DatePicker';

export const MultiDestinationPackedUnits = ({ data, parentIndex, parentData, isProductArchived }) => {
  const { t } = useTranslation('common');

  const {
    purchaseOrderData: { sizesData, legLengths },
  } = useSelector((reduxState) => reduxState);
  const { calculateDestinationPackedUnits } = useDestinationPackedUnits();
  const { calculateGrandTotal } = useGrandTotal();
  const {
    purchaseOrderState: { selectedCurrency },
    setPurchaseOrderState,
    disableConditions,
    purchaseOrderState,
    fromPreview,
    isPublicPoPage,
    poAddEditAccess,
    poDeleteAccess,
    lengthEnabled,
  } = usePurchaseOrderState();

  const AddPath = 'COMMON_LABEL.ADD';
  const deletePath = 'COMMON_LABEL.DELETE';

  const addRow = async (element, colIndex) => {
    const copyState = cloneDeep(data[colIndex]);
    copyState.leftColumn.push(element);
    const obj = cloneDeep(await calculateDestinationPackedUnits(copyState));
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].ratioPacks[${colIndex}]`, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(CopyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const addRightRow = async (element, colIndex) => {
    const copyState = cloneDeep(data[colIndex]);
    copyState.rigthColumn.push(element);
    const obj = cloneDeep(await calculateDestinationPackedUnits(copyState));
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].ratioPacks[${colIndex}]`, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(CopyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const deleteRow = async (i, colIndex) => {
    const copyState = cloneDeep(data[colIndex]);
    copyState.leftColumn.splice(i, 1);
    const obj = cloneDeep(await calculateDestinationPackedUnits(copyState));
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].ratioPacks[${colIndex}]`, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(CopyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const deleteRightRow = async (i, columnIndex) => {
    const copyState = cloneDeep(data[columnIndex]);
    copyState.rigthColumn.splice(i, 1);
    const obj = cloneDeep(await calculateDestinationPackedUnits(copyState));
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].ratioPacks[${columnIndex}]`, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(CopyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const onChange = async (value, keyValue, i) => {
    const copyState = purchaseOrderState;
    set(copyState, keyValue, value);
    const multiDestinationPackedPath = colourPath(parentIndex, i).MULTI_DESTINATION_PACKED_UNITS.COMMON_PATH;
    const multDestipackedUnits = cloneDeep(get(copyState, multiDestinationPackedPath));
    const obj = cloneDeep(await calculateDestinationPackedUnits(multDestipackedUnits));
    set(copyState, multiDestinationPackedPath, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(copyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const addNewCard = async (element) => {
    const copyState = cloneDeep(data);
    const tempEle = element;
    tempEle.shipmentDate = null;
    tempEle.handOverDate = null;
    copyState.push(tempEle);
    const obj = cloneDeep(await calculateDestinationPackedUnits(copyState));
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].ratioPacks`, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(CopyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const deleteExistingCard = async (i) => {
    const copyState = cloneDeep(data);
    copyState.splice(i, 1);
    const obj = cloneDeep(await calculateDestinationPackedUnits(copyState));
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].ratioPacks`, obj);
    const obj2 = cloneDeep(await calculateGrandTotal(CopyState));
    setPurchaseOrderState((prevState) => ({ ...prevState, ...obj2 }));
  };

  const changeHandOverDate = (e, i) => {
    const copyState = cloneDeep(data);
    const tempEle = data[i];
    tempEle.handOverDate = e;
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].ratioPacks[${i}]`, tempEle);
    setPurchaseOrderState((prevState) => ({ ...prevState, ...copyState }));
  };

  const changeShipmentDate = (e, i) => {
    const copyState = cloneDeep(data);
    const tempEle = data[i];
    tempEle.shipmentDate = e;
    const CopyState = { ...purchaseOrderState };
    set(CopyState, `templateJsonSchema[${parentIndex}].ratioPacks[${i}]`, tempEle);
    setPurchaseOrderState((prevState) => ({ ...prevState, ...copyState }));
  };

  const forTotalUnits = (ele, object) => {
    return object?.packsQuantity && ele?.totalPackRatio && !object?.totalUnits
      ? parseInt(ele?.totalPackRatio) * parseInt(object?.packsQuantity)
      : parseInt(object?.totalUnits);
  };

  const hasDate = (element) => {
    return element ? new Date(element) : null;
  };

  return data?.map((ele, i) => {
    return (
      <Card key={i} className="card-margin-bottom rounded-0">
        <Card.Header className="bgcolor-dark rounded-0">
          <div className="d-flex  align-items-center p-2">
            <strong>{t('FILTER.MULTI_DESTINATION')}</strong>
            <div className="date px-3 ml-auto">
              <div className="input-button-container bg-white">
                <CustomDatePicker
                  dateFormat="dd/MM/yyyy"
                  name={t('FILTER.HANDOVER_DESITNATION')}
                  popperPlace="top-end"
                  placeholder={t('FILTER.HANDOVER_DATE')}
                  disable={disableConditions() || fromPreview || isPublicPoPage || !poAddEditAccess}
                  onChange={(e) => changeHandOverDate(e, i)}
                  keyProp={`handOverDate_${parentIndex}_${i}_MultiDestinationPack`}
                  valueProp={hasDate(data[i]?.handOverDate)}
                />
              </div>
            </div>
            <div className="date justify-content-end px-1">
              <div className="input-button-container bg-white">
                <CustomDatePicker
                  dateFormat="dd/MM/yyyy"
                  name={t('FILTER.SHIPMENT_MULTIDESTINATION')}
                  popperPlace="top-end"
                  placeholder={t('FILTER.SHIPMENT_DATE')}
                  keyProp={`shipmentDate_${parentIndex}_${i}_MultiDestinationPack`}
                  disable={disableConditions() || fromPreview || isPublicPoPage || !poAddEditAccess}
                  onChange={(e) => changeShipmentDate(e, i)}
                  valueProp={hasDate(data[i]?.shipmentDate)}
                />
              </div>
            </div>
          </div>
        </Card.Header>
        {!fromPreview && !isPublicPoPage && (
          <div className="d-flex pt-2 justify-content-end">
            {data?.length === i + 1 && poAddEditAccess && (
              <button
                className="btn btn-outline"
                type="button"
                disabled={disableConditions() || isProductArchived}
                onClick={() => addNewCard(ele)}
                title={t(AddPath)}
                aria-label={t(AddPath)}
              >
                <i className="icon-add" />
              </button>
            )}
            {data?.length !== 1 && poDeleteAccess && (
              <button
                className="btn btn-outline px-1"
                type="button"
                disabled={disableConditions() || isProductArchived}
                onClick={() => deleteExistingCard(i)}
                title={t(deletePath)}
                aria-label={t(deletePath)}
              >
                <i className="icon-delete" />
              </button>
            )}
          </div>
        )}
        <Card.Body>
          <div className="table-responsive">
            <table className="table custom-table font-13 mb-5">
              <thead>
                <tr>
                  <th>{t('ORDER_PREVIEW_DETAILS.SIGE')}</th>
                  {lengthEnabled && <th>{t('FILTER.LENGTH')}</th>}
                  <th>{t('FILTER.PACK_RATIO')}</th>
                  <th>{t('FILTER.PRICE_PER_UNIT_RATIO')}</th>
                  <th>{t('FILTER.DISCOUNT_PER_UNIT')}</th>
                  <th>{t('FILTER.PRICE_PER_UNIT_DISCOUNT')}</th>
                  {!fromPreview && !isPublicPoPage && <th>{t('COSTING_TO_DO_LIST.ACTION')}</th>}
                </tr>
              </thead>
              <tbody>
                {ele?.leftColumn.map((element, index) => {
                  return (
                    ((fromPreview && isPublicPoPage && element?.size) || (!fromPreview && !isPublicPoPage)) && (
                      <tr key={index}>
                        <td>
                          <div className="custom-react-select">
                            <Select
                              name="Size"
                              options={sizesData}
                              getOptionLabel={(option) => `${option?.name}`}
                              getOptionValue={(option) => `${option?.name}`}
                              value={(element?.size || typeof element?.size === 'number' ? { name: element?.size } : null) || ''}
                              maxMenuHeight={129}
                              menuPlacement="bottom"
                              menuPosition="fixed"
                              menuShouldBlockScroll
                              menuShouldScrollIntoView
                              isDisabled={disableConditions() || fromPreview || isPublicPoPage || !poAddEditAccess || isProductArchived}
                              styles={customStyles}
                              onChange={(event) => onChange(event?.name, colourPath(parentIndex, i, index)?.MULTI_DESTINATION_PACKED_UNITS?.SIZE_PATH, i)}
                              placeholder={t('FILTER.SELECT_SIZE')}
                            />
                          </div>
                        </td>
                        {lengthEnabled && (
                          <td>
                            <Select
                              name="Length"
                              options={legLengths}
                              getOptionLabel={(option) => `${option?.name}`}
                              getOptionValue={(option) => `${option?.name}`}
                              value={(element?.length ? element?.length : null) || ''}
                              styles={customStyles}
                              maxMenuHeight={129}
                              menuPlacement="bottom"
                              menuPosition="fixed"
                              menuShouldBlockScroll
                              menuShouldScrollIntoView
                              isDisabled={disableConditions() || fromPreview || isPublicPoPage || !poAddEditAccess || isProductArchived}
                              onChange={(event) =>
                                onChange({ name: event?.name }, colourPath(parentIndex, i, index)?.MULTI_DESTINATION_PACKED_UNITS?.LENGTH_PATH, i)
                              }
                              placeholder={t('FILTER.SELECT_LENGTH')}
                            />
                          </td>
                        )}
                        <td>
                          <input
                            type="text"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => allowOnlyNumber(e)}
                            name="Pack Ratio"
                            placeholder={t('FILTER.PACK_RATIO')}
                            className="form-control text-bordered"
                            value={element?.packRatio || ''}
                            disabled={disableConditions() || fromPreview || isPublicPoPage || !poAddEditAccess || isProductArchived}
                            onChange={(e) => onChange(e.target.value, colourPath(parentIndex, i, index)?.MULTI_DESTINATION_PACKED_UNITS?.PACK_RATIO, i)}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => allowOnlyNumber(e)}
                            name="Price Per Unit (Before Discount)"
                            placeholder={t('FILTER.PRICE_PER_UNIT_RATIO')}
                            className="form-control text-bordered"
                            value={element?.beforeDiscPrice || ''}
                            disabled={disableConditions() || fromPreview || isPublicPoPage || !poAddEditAccess || isProductArchived}
                            onChange={(e) => onChange(e.target.value, colourPath(parentIndex, i, index)?.MULTI_DESTINATION_PACKED_UNITS?.BEFORE_DESCOUNT, i)}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => allowOnlyNumber(e)}
                            name="Discount"
                            placeholder={t('PROGRESS_INDICATOR.DISCOUNT')}
                            className="form-control text-bordered"
                            value={element?.discount || ''}
                            disabled={disableConditions() || fromPreview || isPublicPoPage || !poAddEditAccess || isProductArchived}
                            onChange={(e) => onChange(e.target.value, colourPath(parentIndex, i, index)?.MULTI_DESTINATION_PACKED_UNITS?.DISCOUNT, i)}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => allowOnlyNumber(e)}
                            name="Price Per Unit (After Discount)"
                            placeholder={t('FILTER.PRICE_PER_UNIT_DISCOUNT')}
                            className="form-control text-bordered"
                            value={(element?.afterDiscPrice ? roundingOff(element?.afterDiscPrice, 2) : null) || ''}
                            readOnly
                            disabled={disableConditions() || fromPreview || isPublicPoPage || !poAddEditAccess || isProductArchived}
                            onChange={(e) => onChange(e.target.value, colourPath(parentIndex, i, index)?.MULTI_DESTINATION_PACKED_UNITS?.AFTER_DISCOUNT, i)}
                          />
                        </td>
                        {!fromPreview && !isPublicPoPage && (
                          <td>
                            <div className="d-flex">
                              {poAddEditAccess && (
                                <button
                                  disabled={disableConditions() || fromPreview || isPublicPoPage || isProductArchived}
                                  type="button"
                                  title={t(AddPath)}
                                  aria-label={t(AddPath)}
                                  className="btn btn-outline"
                                  onClick={() => addRow(element, i)}
                                >
                                  <i className="icon-add" />
                                </button>
                              )}
                              {ele?.leftColumn?.length !== 1 && poDeleteAccess && (
                                <button
                                  disabled={disableConditions() || fromPreview || isPublicPoPage || isProductArchived}
                                  title={t(deletePath)}
                                  aria-label={t(deletePath)}
                                  type="button"
                                  className="btn btn-outline px-1"
                                  onClick={() => deleteRow(index, i)}
                                >
                                  <i className="icon-delete" />
                                </button>
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    )
                  );
                })}
                <tr key={i}>
                  <td colSpan={9}>
                    <strong className="d-flex align-item-center justify-content-center">{t('ORDER_PREVIEW_DETAILS.TOTAL')}</strong>
                  </td>
                </tr>
                <tr key={i}>
                  <td>
                    {((fromPreview && isPublicPoPage && ele?.totalSize) || !fromPreview || !isPublicPoPage) && (
                      <strong>{ele?.totalSize ? roundingOff(ele?.totalSize, 2) : null}</strong>
                    )}
                  </td>
                  <td>
                    {((fromPreview && isPublicPoPage && ele?.totalLength) || !fromPreview || !isPublicPoPage) && (
                      <strong>{ele?.totalLength ? roundingOff(ele?.totalLength, 2) : null}</strong>
                    )}
                  </td>
                  <td>
                    {((fromPreview && isPublicPoPage && ele?.totalPackRatio) || !fromPreview || !isPublicPoPage) && (
                      <strong>{ele?.totalPackRatio ? roundingOff(ele?.totalPackRatio, 2) : null}</strong>
                    )}
                  </td>
                  <td>
                    {((fromPreview && !isPublicPoPage && ele?.totalPriceBeforeDisc) || !fromPreview || !isPublicPoPage) &&
                      (ele?.totalPriceBeforeDisc ? (
                        <strong>
                          <span className="px-1">
                            {currency_symbols[selectedCurrency?.label] ? currency_symbols[selectedCurrency?.label] : selectedCurrency?.label}
                          </span>
                          {roundingOff(ele?.totalPriceBeforeDisc, 2)}
                        </strong>
                      ) : null)}
                  </td>
                  <td>
                    {((fromPreview && isPublicPoPage && ele?.totalDiscountPerUnit) || !fromPreview || !isPublicPoPage) && (
                      <strong>{ele?.totalDiscountPerUnit ? roundingOff(ele?.totalDiscountPerUnit, 2) : null}</strong>
                    )}
                  </td>
                  <td colSpan={2}>
                    {((fromPreview && isPublicPoPage && ele?.totalSize) || !fromPreview || !isPublicPoPage) &&
                      (ele?.totalPriceAfterDisc ? (
                        <strong>
                          <span className="px-1">
                            {currency_symbols[selectedCurrency?.label] ? currency_symbols[selectedCurrency?.label] : selectedCurrency?.label}
                          </span>
                          {roundingOff(ele?.totalPriceAfterDisc, 2)}
                        </strong>
                      ) : null)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="table-responsive">
            <table className="table custom-table font-13 mb-3">
              <thead>
                <th colSpan={5} />
                <th>{t('ORDER_PREVIEW_DETAILS.ACTION')}</th>
              </thead>
              <tbody>
                {ele.rigthColumn.map((object, ind) => {
                  return (
                    <tr key={ind}>
                      <td colSpan={5}>
                        <input
                          type="text"
                          name="destination"
                          placeholder={t('FILTER.DESTINATION1')}
                          className="form-control text-bordered text-bordered"
                          value={object?.destination || ''}
                          disabled={disableConditions() || !poAddEditAccess || isProductArchived}
                          onChange={(e) => onChange(e.target.value, colourPath(parentIndex, i, ind)?.MULTI_DESTINATION_PACKED_UNITS?.DESTINATION, i)}
                        />
                        <div className="d-flex align-items-center my-1">
                          <span>{`Total Packs for ${object?.destination ? object?.destination : 'Destination-1'}`}</span>
                          <div className="ml-auto">
                            <input
                              type="text"
                              onWheel={(e) => e.target.blur()}
                              onKeyDown={(e) => allowOnlyNumber(e)}
                              name="packsQuantity"
                              placeholder={t('FILTER.TOTAL_PACK')}
                              className="form-control text-bordered text-bordered"
                              value={(object?.packsQuantity ? new Intl.NumberFormat().format(roundingOff(object?.packsQuantity, 2)) : null) || ''}
                              disabled={disableConditions() || fromPreview || isPublicPoPage || !poAddEditAccess || isProductArchived}
                              onChange={(e) =>
                                onChange(e.target.value, colourPath(parentIndex, i, ind)?.MULTI_DESTINATION_PACKED_UNITS?.TOTAL_DESTINATION_PACKING_QTY, i)
                              }
                            />
                          </div>
                        </div>
                        <div className="d-flex align-items-center my-1">
                          <span>{`Total Units for ${object?.destination ? object?.destination : 'Destination-1'}`}</span>
                          <div className="ml-auto">
                            <input
                              type="text"
                              onWheel={(e) => e.target.blur()}
                              onKeyDown={(e) => allowOnlyNumber(e)}
                              name="totalUnits"
                              placeholder={t('FILTER.TOTAL_UNITS')}
                              className="form-control text-bordered text-bordered"
                              value={((object?.packsQuantity && ele?.totalPackRatio) || object?.totalUnits ? forTotalUnits(ele, object) : null) || ''}
                              disabled={disableConditions() || fromPreview || isPublicPoPage || !poAddEditAccess || isProductArchived}
                              onChange={(e) =>
                                onChange(e.target.value, colourPath(parentIndex, i, ind)?.MULTI_DESTINATION_PACKED_UNITS?.TOTAL_DESTINATION_TOTAL_UNIT, i)
                              }
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        {!fromPreview && !isPublicPoPage && poAddEditAccess && (
                          <button
                            title={t(AddPath)}
                            aria-label={t(AddPath)}
                            type="button"
                            disabled={disableConditions() || fromPreview || isPublicPoPage || isProductArchived}
                            className="btn btn-outline"
                            onClick={() => addRightRow(object, i)}
                          >
                            <i className="icon-add" />
                          </button>
                        )}
                        {!fromPreview && !isPublicPoPage && ind !== 0 && poDeleteAccess && (
                          <button
                            title={t(deletePath)}
                            aria-label={t(deletePath)}
                            type="button"
                            className="btn btn-outline px-1"
                            disabled={disableConditions() || fromPreview || isPublicPoPage || isProductArchived}
                            onClick={() => deleteRightRow(ind, i)}
                          >
                            <i className="icon-delete" />
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
                <tr key={i}>
                  <td colSpan={7}>
                    <strong className="d-flex align-item-center justify-content-center">{t('ORDER_PREVIEW_DETAILS.TOTAL')}</strong>
                  </td>
                </tr>
                <tr key={i}>
                  <td />
                  <td colSpan={2} />
                  <td />
                  <td>
                    <strong>{t('FILTER.TOTAL_PACK:')}</strong>
                  </td>
                  <td>
                    <strong>
                      {ele.rigthColumn?.[0]?.packsQuantity
                        ? new Intl.NumberFormat().format(roundingOff(sum(ele.rigthColumn.map((obj) => parseInt(obj?.packsQuantity, 10))), 2).toString())
                        : null}
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4} />
                  <td>
                    <strong>{t('FILTER.TOTAL_UNITS:')}</strong>
                  </td>
                  <td>
                    <strong>
                      {ele.rigthColumn?.[0]?.totalUnits || (ele.rigthColumn?.[0]?.packsQuantity && ele?.totalPackRatio)
                        ? new Intl.NumberFormat().format(
                            roundingOff(
                              sum(
                                ele.rigthColumn.map((obj) =>
                                  obj?.packsQuantity && ele?.totalPackRatio && !obj?.totalUnits
                                    ? parseInt(ele?.totalPackRatio, 10) * parseInt(obj?.packsQuantity, 10)
                                    : parseInt(obj?.totalUnits, 10),
                                ),
                              ),
                              2,
                            ).toString(),
                          )
                        : null}
                    </strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <Row>
            <Col lg={6} className="span_font_size ">
              <div className="mb-2">
                <span>{`Total Units of '${parentData?.colorWay?.name}' Colourway:`}</span>
                <input
                  type="text"
                  name="grandTotalUnit"
                  placeholder={t('FILTER.GRAND_TOTAL_UNIT')}
                  className="form-control  showBtmBrdr"
                  readOnly
                  disabled={disableConditions() || fromPreview || isPublicPoPage || !poAddEditAccess || isProductArchived}
                  value={(parentData?.grandTotalUnit ? new Intl.NumberFormat().format(roundingOff(parentData?.grandTotalUnit, 2)) : null) || ''}
                />
              </div>
              <div className="mb-2">
                <span>{`Total Price (After Discount): of '${parentData?.colorWay?.name}' Colourway:`}</span>
                <div className="d-flex">
                  <input
                    type="text"
                    name="totalAfterDisc"
                    placeholder={t('FILTER.TOTAL_AFTER_DISCOUNT')}
                    disabled={disableConditions() || fromPreview || isPublicPoPage || !poAddEditAccess || isProductArchived}
                    className="form-control  showBtmBrdr"
                    readOnly
                    value={(parentData?.totalAfterDisc ? new Intl.NumberFormat().format(roundingOff(parentData?.totalAfterDisc, 2)) : null) || ''}
                  />
                  <span className="px-1">
                    {currency_symbols[selectedCurrency?.label] ? currency_symbols[selectedCurrency?.label] : selectedCurrency?.label}
                  </span>
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <div>
                <span>{`Total Price (Before Discount): of '${parentData?.colorWay?.name}' Colourway:`}</span>
                <div className="d-flex">
                  <input
                    type="text"
                    name="totalBeforeDisc"
                    placeholder={t('FILTER.TOTAL_BEFORE_DISCOUNT')}
                    className="form-control  showBtmBrdr"
                    readOnly
                    disabled={disableConditions() || fromPreview || isPublicPoPage || !poAddEditAccess || isProductArchived}
                    value={(parentData?.totalBeforeDisc ? new Intl.NumberFormat().format(roundingOff(parentData?.totalBeforeDisc, 2)) : null) || ''}
                  />
                  <span className="px-1">
                    {currency_symbols[selectedCurrency?.label] ? currency_symbols[selectedCurrency?.label] : selectedCurrency?.label}
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  });
};

export default MultiDestinationPackedUnits;
